import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Constants imports
import { URLConstants } from '../../../../_constants/url-constants';
// Model imports
import { ARMiscInvoiceEditorResultDto } from '../../_models/account-receivable/ar-misc-invoice/ar-misc-invoice-editor-result-dto';
import { MiscInvoiceGLSubCategoryResultDto } from '../../_models/account-receivable/ar-misc-invoice/misc-invoice-gl-subcategory-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ARMiscInvoiceService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getARMiscInvoiceEditor(cId, mcId) {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/editor?communityId=${cId}&managementCompanyId=${mcId}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(ARMiscInvoiceEditorResultDto, response)));
    }
    getARMiscInvoiceSubcategories(param) {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/subcategories${param.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(MiscInvoiceGLSubCategoryResultDto, response)));
    }
    validateMiscInvoicePayment(param) {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc/payment/validate`;
        return this.httpClient.post(url, classToPlain(param));
    }
    createARMiscInvoice(param) {
        const url = `${URLConstants.ccInvoiceApiUrl}/misc`;
        return this.httpClient.post(url, classToPlain(param));
    }
}
ARMiscInvoiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ARMiscInvoiceService_Factory() { return new ARMiscInvoiceService(i0.ɵɵinject(i1.HttpClient)); }, token: ARMiscInvoiceService, providedIn: "root" });
